import { createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsFee } from '../types/eecs-fees.types';

interface EecsFeesInitialState extends BaseDataReducerInitialState<IEecsFee> {}

const { initialState, AC, reducer, thunks } = basedDataReducer<IEecsFee, EecsFeesInitialState>('eecs-fees');

const eecsFeesInitialState: EecsFeesInitialState = {
  ...initialState,
  perPage: 25,
};

export const eecsFees = createSlice({
  name: 'eecsFees',
  initialState: eecsFeesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsFeesInitialState, action);
    });
  },
});

export const EecsFeesAC = AC;
export const onEecsFeesFilter = thunks.onFilter;
export const setEecsFeesCurrentPage = AC.setCurrentPage;
